import { __ } from "@wordpress/i18n";
import {
	useBlockProps,
	InspectorControls,
	InnerBlocks,
} from "@wordpress/block-editor";
import { useSelect } from "@wordpress/data";
import ResponsiveSpacingControl from "../components/ResponsiveSpacingControl";
import DisplayTypeControl from "../components/DisplayTypeControl";
import ResponsiveFlexControl from "../components/ResponsiveFlexControl";
import ResponsiveGapControl from "../components/ResponsiveGapControl";
import { getAllSpacingVars } from "../utils/spacingUtils";
import { getAllFlexboxVars } from "../utils/flexboxUtils";

export default function Edit({ attributes, setAttributes }) {
	const { displayType = "block" } = attributes;

	const deviceType = useSelect(
		(select) =>
			select("core/edit-post")?.__experimentalGetPreviewDeviceType?.() ||
			select("core/editor")?.getDeviceType?.(),
		[],
	);

	const spacingVars = getAllSpacingVars(attributes);
	const flexboxVars = getAllFlexboxVars(attributes);

	// Combine all CSS vars
	const style = { ...spacingVars, ...flexboxVars };

	// Override desktop vars for tablet/mobile preview
	if (deviceType === "Tablet") {
		Object.entries(style).forEach(([key, value]) => {
			if (key.includes("tablet"))
				style[key.replace("tablet", "desktop")] = value;
		});
	} else if (deviceType === "Mobile") {
		Object.entries(style).forEach(([key, value]) => {
			if (key.includes("mobile"))
				style[key.replace("mobile", "desktop")] = value;
		});
	}

	const blockProps = useBlockProps({
		className: `wp-block-sfb-container ${
			displayType === "flex" ? "is-flex" : ""
		}`,
		style,
	});

	return (
		<>
			<InspectorControls>
				<DisplayTypeControl
					attributes={attributes}
					setAttributes={setAttributes}
				/>

				{displayType === "flex" && (
					<>
						<ResponsiveFlexControl
							attributes={attributes}
							setAttributes={setAttributes}
						/>
						<ResponsiveGapControl
							attributes={attributes}
							setAttributes={setAttributes}
						/>
					</>
				)}

				<ResponsiveSpacingControl
					label={__("Padding", "sfb")}
					attributeName="padding"
					attributes={attributes}
					setAttributes={setAttributes}
				/>
				<ResponsiveSpacingControl
					label={__("Margin", "sfb")}
					attributeName="margin"
					attributes={attributes}
					setAttributes={setAttributes}
				/>
			</InspectorControls>

			<div {...blockProps}>
				<InnerBlocks />
			</div>
		</>
	);
}
